import React from "react";
import "./AboutUs.css";

function AboutUs() {
  return (
    <section className="about-us-section">
      <div className="about-us-container">
        <h2 className="section-title">
          ABOUT <span className="highlight">EAVER</span>
        </h2>

        <p>
          <strong>EAVER</strong> is a trusted engineering solutions provider
          delivering high-quality electrical products, project services, and
          technical expertise to industrial, EPC, and utility clients across
          multiple sectors.
        </p>

        <p>
          With 19 years of experience in the power and industrial domain, EAVER
          specializes in HV &amp; LV electrical systems, substations up to 400
          kV, power equipment supply, testing &amp; commissioning, and
          operation &amp; maintenance services. Our solutions are designed to
          enhance power reliability, operational efficiency, and long-term
          asset performance.
        </p>

        <p>
          We partner with power plants, transmission utilities, oil &amp; gas
          facilities, cement plants, process industries, and infrastructure
          projects, offering end-to-end support from detailed engineering and
          material supply to installation, testing, commissioning, and
          after-sales service.
        </p>

        <p>
          EAVER is driven by a commitment to quality, safety, and international
          standards. Every product we supply and every service we deliver is
          carefully selected and executed to meet stringent technical
          requirements and global benchmarks.
        </p>

        <p>
          Backed by a skilled team of engineers, technicians, and project
          professionals, EAVER stands as a reliable partner for clients seeking
          efficient execution, technical excellence, and sustainable power
          solutions.
        </p>

        <div className="eaver-offerings">
          <h3>EAVER Offerings</h3>
          <p>
            EAVER delivers comprehensive electrical engineering solutions and
            reliable power infrastructure products tailored for industrial,
            EPC, and utility clients.
          </p>
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
